import { urlFeedback } from '../../../../../server/utils/urlConstants';

/* Confirmation Dialog */
export const confirmThankYou = 'Thank you!'.toUpperCase();
export const confirmTagLine = 'See you in your inbox';
export const icon = `${urlFeedback}email-airplane.svg`;
